import { request } from '@/shared'

export const getCurrency = () => request<Array<{ name: string; symbol: string }>>('get', '/static/currency')

export const getTransactionCategories = () => request<Array<{ title: string; value: string }>>('get', '/static/transaction-categories')
